import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Termos = () => {
    const navigate = useNavigate();

    return (
        <Container style={{ background: "#f4f4f4" }} className="my-5 p-3 border rounded shadow-sm">
            <h2 className="mb-4 text-center" style={{ color: "#8fad15" }}>Política Geral de Privacidade</h2>
            <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                <p>
                    A Motomco | Loc Solution agradece seu interesse em nossa marca e sua
                    confiança ao compartilhar seus dados conosco. Sua privacidade é
                    importante para nós, portanto tratamos de produzir esse termo da forma
                    mais transparente possível sobre como coletamos, usamos e compartilhamos
                    informações sobre você.
                </p>
                <p>
                    Ao usar o site ou outras mídias ou meios digitais da Motomco | Loc
                    Solution, você reconhece e concorda com as condições desta Política de
                    Privacidade e autoriza a coleta e uso das informações fornecidas
                    diretamente para nós.
                </p>
                <h4 style={{ color: "#8fad15" }}>Coleta de Informações</h4>
                <p>
                    Coletamos informações sobre você quando usa nossos serviços ou outras
                    fontes as fornecem a nós. Podemos receber informações de fornecedores
                    terceirizados de informações comerciais e fontes disponíveis publicamente
                    (como plataformas de mídia social), incluindo endereços de correio físicos,
                    cargos, endereços de e-mail, números de telefone, dados de intenção
                    (ou dados de comportamento do usuário), Endereços IP e perfis de mídia social,
                    para fins de publicidade direcionada de produtos que podem interessar a você.
                </p>
                <h4 style={{ color: "#8fad15" }}>Dados Não Considerados Pessoais</h4>
                <p>
                    Dados de pessoas jurídicas, como CNPJ, razão social ou inscrição estadual,
                    não são considerados dados pessoais.
                </p>
                <h4 style={{ color: "#8fad15" }}>Compartilhamento de Informações</h4>
                <p>
                    Compartilhamos informações que coletamos sobre você com terceiros que nos ajudam
                    a melhorar a sua experiência com nossos produtos e serviços. As empresas com
                    as quais compartilhamos suas informações adotam as medidas necessárias para
                    garantir o sigilo e proteção dos dados, dentro do mesmo nível de segurança
                    praticado pela Motomco | Loc Solution.
                </p>
                <h4 style={{ color: "#8fad15" }}>Conformidade com a Lei Geral de Proteção de Dados</h4>
                <p>
                    Todas as informações pessoais serão tratadas em concordância com a Lei Geral
                    de Proteção de Dados. Caso não queira informar seus dados pessoais, algumas
                    funcionalidades podem não estar disponíveis.
                </p>
                <h4 style={{ color: "#8fad15" }}>Coleta Automática</h4>
                <p>
                    Além das informações inseridas ativamente, também podemos coletar informações
                    de forma automática, como endereço IP, data e hora da conexão e páginas visualizadas.
                </p>
                <h4 style={{ color: "#8fad15" }}>Informações para Menores de Idade</h4>
                <p>
                    Não coletamos intencionalmente informações pessoais de menores de idade. Se o usuário
                    for menor, deve solicitar a seus pais ou responsáveis para o uso dos sites.
                </p>
                <h4 style={{ color: "#8fad15" }}>Comunicação com Usuário</h4>
                <p>
                    A Motomco | Loc Solution poderá enviar informações sobre produtos, serviços e
                    promoções através de ferramentas de comunicação como WhatsApp e e-mail.
                </p>
                <h4 style={{ color: "#8fad15" }}>Conexões com Sites de Terceiros</h4>
                <p>
                    Nossos sites podem conter links para sites de terceiros. Não nos responsabilizamos
                    pelas políticas de privacidade de sites externos.
                </p>
                <h4 style={{ color: "#8fad15" }}>Contato para Dúvidas</h4>
                <p>
                    Em caso de dúvidas, entre em contato pelo e-mail: <a href="mailto:sac@locsolution.com">sac@locsolution.com</a>.
                </p>
                <h4 style={{ color: "#8fad15" }}>Revogação de Consentimento</h4>
                <p>
                    Você pode revogar seu consentimento a qualquer momento enviando uma solicitação
                    formal para o e-mail: <a href="mailto:sac@locsolution.com">sac@locsolution.com</a>.
                </p>
            </div>
        </Container>
    );
};

export default Termos;
